'use strict';

var React = require('react'),
    GalleryImage = require('./GalleryImage'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    SectionTypes = require('../constants/SectionTypes');

require('./legacy/Stamp.less');
require('./GridGallery.less');

var IMAGE_SIZES = {
  'default': 480,
  'xs': 512,
  'sm': 512,
  'md': 512,
  'lg': 512,
  'xl': 640
};

var ITEMS_IN_ROW = 2;

var GridGallery = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    stamp: React.PropTypes.object.isRequired,
    images: React.PropTypes.array.isRequired,
    sectionIndex: React.PropTypes.number.isRequired,
    lightboxState: React.PropTypes.oneOf(['active', 'leaving']),
    toggleLightbox: React.PropTypes.func.isRequired,
    getLightboxImageStyle: React.PropTypes.func.isRequired,
    isImageInLightbox: React.PropTypes.func.isRequired,
    onImageTransitionEnd: React.PropTypes.func.isRequired
  },

  getImageSizes: function () {
    return IMAGE_SIZES;
  },

  getRows() {
    var { images } = this.props,
        rows = [];

    for (var i = 0; i < images.length; i += ITEMS_IN_ROW) {
      rows.push(images.slice(i, i + ITEMS_IN_ROW).filter(Boolean));
    }

    return rows;
  },

  render: function () {
    return (
      <div className='stamp-GridGallery'
           data-lightbox={this.props.lightboxState}>
        <div className='stamp-GridGallery-box'>
          {this.getRows().map(this.renderRow)}
        </div>
      </div>
    );
  },

  renderRow(row, index) {
    return (
      <div className='stamp-GridGallery-row' key={index}>
        {row.map(this.renderImage)}
      </div>
    );
  },

  renderImage: function (image, indexInRow, row) {
    var imageStyle = this.props.getLightboxImageStyle(image),
        caption = image.caption,
        galleryStyle = {},
        siblingImage = indexInRow === 0 ? row[1] : row[0];

    galleryStyle.flex = 1;
    galleryStyle.MozFlex = 1;
    galleryStyle.WebkitFlex = 1;
    galleryStyle.msFlex = 1;

    if (siblingImage) {
      galleryStyle.flex = siblingImage.size.height / siblingImage.size.width;
      galleryStyle.MozFlex = siblingImage.size.height / siblingImage.size.width;
      galleryStyle.WebkitFlex = siblingImage.size.height / siblingImage.size.width;
      galleryStyle.msFlex = siblingImage.size.height / siblingImage.size.width;
    }

    return (
      <GalleryImage key={indexInRow}
                    className='stamp-GridGallery-item'
                    style={galleryStyle}
                    stamp={this.props.stamp}
                    image={image}
                    imageSizes={IMAGE_SIZES}
                    imageStyle={imageStyle}
                    caption={caption}
                    onClick={this.handleImageClick}
                    onTransitionEnd={this.props.onImageTransitionEnd}
                    isImageInLightbox={this.props.isImageInLightbox}
                    lightboxState={this.props.lightboxState} />
    );
  },

  handleImageClick: function (image, e) {
    var boundingRect = e.target.getBoundingClientRect();
    this.props.toggleLightbox(
      this.props.sectionIndex,
      SectionTypes.GALLERY,
      image,
      boundingRect
    );
  }
});

module.exports = GridGallery;



/** WEBPACK FOOTER **
 ** ./stamp/GridGallery.jsx
 **/